import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { RotatingLines } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import CommonCarousel from '../../../components/common-carousel/CommonCarousel';
import EmptyState from '../../../components/empty-state/EmptyState';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { clampMediaIndex } from '../../utils/mediaIndex';

import scss from './ContentSlider.module.scss';

function ContentSlider({
  slides,
  Slide,

  slideProps = {},
  isLoading = false,

  index = 0,
  onSwipe,
  isGenerating,
  contrastedArrows,
  enableArrowNavigation,
}) {
  const { t } = useTranslation();
  const carouselRef = useRef(null);
  const safeIndex = clampMediaIndex(index, slides.length);

  useEffect(() => {
    carouselRef.current?.goToSlide(safeIndex);
  }, [safeIndex]);

  return (
    <div className={clsx(scss.sliderWrapper)}>
      {slides.length ? (
        <CommonCarousel
          ref={carouselRef}
          onBeforeChange={onSwipe}
          initialSlide={safeIndex}
          isLazyLoad
          draggable={!isGenerating}
          contrastedArrows={contrastedArrows}
          swipe={!isGenerating}
          enableArrowNavigation={enableArrowNavigation}>
          {slides.map((slide) => (
            <Slide key={slide.id} slide={slide} {...slideProps} />
          ))}
        </CommonCarousel>
      ) : (
        <div className={scss.emptySlide}>
          <EmptyState
            bordered={false}
            icon={<Icon icon={ICONS.Unclust} disableCommonStyles currentColor />}
            title={t('noData')}
          />
        </div>
      )}

      {isLoading && (
        <div className={scss.loaderWrapper}>
          <RotatingLines strokeColor='#fdbf47' strokeWidth={5} animationDuration='0.75' width={28} visible={true} />
        </div>
      )}
    </div>
  );
}

export default ContentSlider;
